module.exports = __webpack_public_path__ + "static/media/quiz.c7e49ff7.svg";